import script from "./field-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./field-editor.vue?vue&type=script&setup=true&lang=js"

import "./field-editor.vue?vue&type=style&index=0&id=40d8d3e9&lang=scss"

const __exports__ = script;

export default __exports__